// main.js
import { defineCustomElement } from './assets/defineCustomElementWithStyles'
import App from './App.ce.vue'

customElements.define(
  'inspiration-embed',
  defineCustomElement(App)
)